import { Box, Typography } from "@mui/material";
import React from "react";
import Accordion from "../components/Accordion";
import { Datafaq } from "../components/Datafaq";
import SEO from "../components/SEO";
import { SX } from "../sx";
import { C } from "../tokens";

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: Datafaq.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.reponse,
    },
  })),
};

const Faq = () => (
  <>
    <SEO
      title="FAQ  Questions fréquentes sur l'ostéopathie"
      description="Toutes vos questions sur l'ostéopathie : déroulement d'une séance, remboursements, contre-indications, durée, tarifs… Réponses par Maxime Nicolaieff D.O. à Balma."
      path="/faq"
      schema={FAQ_SCHEMA}
    />
    <Box component="section" sx={SX.pageHeroSection}>
      <Box sx={{ ...SX.pageHeroInner, maxWidth: "720px" }}>
        <Box component="span" sx={SX.sectionLabel}>
          FAQ
        </Box>
        <Typography variant="h1" component="h1" sx={SX.displayTitle}>
          Vos questions, <em>mes réponses.</em>
        </Typography>
        <Typography sx={SX.pageHeroSub}>
          L'essentiel pour préparer sereinement votre première consultation. Une
          autre question ? Contactez-moi au{" "}
          <Box
            component="a"
            href="tel:0695788983"
            sx={{ color: C.primary, "&:hover": { color: C.accent } }}
          >
            06 95 78 89 83
          </Box>
          .
        </Typography>
      </Box>
    </Box>

    <Box
      sx={{
        maxWidth: "720px",
        mx: "auto",
        px: { xs: "1rem", md: "2.5rem" },
        pb: { xs: "3.5rem", md: "5rem" },
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
      }}
    >
      {Datafaq.map((item, i) => (
        <Accordion
          key={i}
          num={String(i + 1).padStart(2, "0")}
          title={item.question}
          content={item.reponse}
        />
      ))}
    </Box>
  </>
);

export default Faq;
